/**
 * Local verification: serve static JSON from `public/api-mock/routes-information/`
 * instead of calling the admin Routes Information API.
 *
 * - **Dev default:** mock is ON (`npm run dev`).
 * - **Production:** mock is OFF unless `VITE_USE_ROUTES_INFORMATION_MOCK=true`.
 * - **Force live API in dev:** `VITE_USE_ROUTES_INFORMATION_MOCK=false` in `.env.local`.
 */

function mockApiBaseUrl(): string {
  const base = import.meta.env.BASE_URL ?? "/";
  return base.endsWith("/") ? base : `${base}/`;
}

export function isRoutesInformationMockEnabled(): boolean {
  const v = import.meta.env.VITE_USE_ROUTES_INFORMATION_MOCK;
  if (v === "false" || v === "0") return false;
  if (v === "true" || v === "1") return true;
  return import.meta.env.DEV;
}

export async function fetchRoutesInformationMockJson<T>(filename: string): Promise<T> {
  const url = `${mockApiBaseUrl()}api-mock/routes-information/${filename}`;
  const res = await fetch(url, { cache: "no-store" });
  if (!res.ok) {
    throw new Error(`Routes information mock missing or failed (${res.status}): ${url}`);
  }
  return (await res.json()) as T;
}
